import { LOCALES } from './types';

export const SORTED_PROD_SUPPORTED_LOCALES = [LOCALES.en_ca, LOCALES.fr_ca, LOCALES.en_us];

export * from './generated/supported-locales.th';
